<!--  -->
<template>
    <div class='bg box_v'>
        <div class="title1">工作专班</div>
        <div class='box_f1' id="echart_gzzb" style="width:100%;height:100%"></div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            type:[],
            count:[],
            bgMaxNumberArr:[],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.meetingNumberByType).then(res=>{
                let max = res.rows[0].count
               
                this.type =  res.rows.map(item=>item.typeName)
                this.count =  res.rows.map(item=>item.count)

                let maxArr = res.rows[0].count.toString().split('')
                maxArr[0] = parseInt(maxArr[0])+1
                maxArr = maxArr.map((item,index)=>{
                    return index?0:item
                    
                })
                let bgMaxNumber = parseInt(maxArr.join(''))
                this.bgMaxNumberArr = new Array(res.rows.length).fill(bgMaxNumber)
                this.initEchart()
            })
        },
        initEchart(){
            let echart = echarts.init(document.getElementById('echart_gzzb'));

            let option = {
                grid:{
                    left:'60'
                },
                xAxis: {
                    type: 'category',
                    data:this.type,
                    
                    axisLabel: {
                        textStyle: {
                            color: '#fff'
                        },
                        formatter: function(params) {
                           let newParamsName = "";
                            let paramsNameNumber = params.length;
                            let provideNumber = 2;  //一行显示几个字
                            let rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                            if (paramsNameNumber > provideNumber) {
                                for (let p = 0; p < rowNumber; p++) {
                                    let tempStr = "";
                                    let start = p * provideNumber;
                                    let end = start + provideNumber;
                                    if (p == rowNumber - 1) {
                                        tempStr = params.substring(start, paramsNameNumber);
                                    } else {
                                        tempStr = params.substring(start, end) + "\n";
                                    }
                                    newParamsName += tempStr;
                                }

                            } else {
                                newParamsName = params;
                            }
                            return newParamsName
                        }
                    },
                    axisLine:{show: false}
                },
                yAxis: [{
                    type: 'value',
                    axisLabel: {
                        textStyle: {
                            color: '#6BD3FF'
                        },
                        formatter: '{value}' + '件',
                    },
                    min: 0,
                    max: this.bgMaxNumberArr[0],
                    splitNumber:this.bgMaxNumberArr[0]>5?5:this.bgMaxNumberArr[0],
                    splitLine:{show: false},//去除网格线
                    axisLine:{show: false}
                }],
                legend: {
                    data: ['提交工作专班数量'],
                    right:'20',
                    textStyle:{
                        color:'#fff'
                    }
                },
                series: [{ // For shadow
                    type: 'bar',
                    itemStyle: {
                        color: 'rgba(127, 127, 127, 0)',
                        borderColor:'#008cff',
                        barBorderRadius:6,
                        barWidth:'10',
                    },
                    barGap: '-100%',
                    barCategoryGap: '15px',
                    barWidth:'10',
                    data: this.bgMaxNumberArr,
                    animation: false
                },{
                    name:'新增实名认证用户量',
                    data: this.count,
                    type: 'bar',
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#0491F3'},
                                {offset: 1, color: '#4020AB'}
                            ]
                        ),
                        barBorderRadius:6,
                        barWidth:'10',
                    },
                    barWidth:'10',
                    barCategoryGap: '15px',
                    // showBackground: true,
                    // backgroundStyle: {
                    //     color: 'rgba(127, 127, 127, 0.5)',
                    //     borderColor:'#fff',
                    //     barBorderRadius:'6px'
                    // }
                }],
                // tooltip: {
                //     trigger: 'axis',
                //     formatter: '{b1}<br />{a1}: {c1}'+this.accessTag+'<br />{a2}: {c2}'+this.realNameTag,
                //     axisPointer: {
                //         type: 'line',
                //     },
                    
                // },

            };
            

            echart.setOption(option)
            
            
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftbottom.png');
    background-size: 100% 100%;
    height:100%;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:20px 0 0 40px
}
</style>